import { isLinkActive } from '@/app/layouts/AsideMenu';
import { ADJUSTMENTS_REPORTS_ITEMS, ADJUSTMENTS_REPORTS_LABEL } from './menuItems';
import { SectionNav } from './SectionNav';

/** True on the four screens of the Adjustments & Reports section (APT348). */
export const isAdjustmentsReportsRoute = (pathname: string): boolean =>
  ADJUSTMENTS_REPORTS_ITEMS.some((i) => isLinkActive(pathname, i.to));

/**
 * APT348 (client): "Create a new section called Adjustments & Reports to consolidate the existing Nominal Mapping, Journals, Adjusted Trial
 * Balance, and Working Papers options ... display these four features in a top navigation grid, in the following sequence". One bar,
 * shown across the top of the content of each of the four screens (SideMenuPage puts it there).
 */
export const AdjustmentsReportsNav = () => (
  <SectionNav label={ADJUSTMENTS_REPORTS_LABEL} items={ADJUSTMENTS_REPORTS_ITEMS} testId="adjustments-nav" />
);
